<div
  class="toast-container"
  aria-live="polite"
  aria-atomic="true"
>
  @for (toast of toasts; track toast.id) {
    <div
      class="toast-card toast-type--{{ toast.icon }}"
      (click)="onToastClick(toast)"
      (mouseenter)="onMouseEnter(toast.id)"
      (mouseleave)="onMouseLeave(toast.id)"
      role="alert"
    >
      <div class="toast-content">
        <!-- Notification Icon -->
        <div class="toast-icon-wrapper toast-icon--{{ toast.icon }}">
          @switch (toast.icon) {
            @case ('code') {
              <svg class="toast-icon stroke-current stroke-2 fill-none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
              </svg>
            }
            @case ('check') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.74-5.25z" clip-rule="evenodd" />
              </svg>
            }
            @case ('document') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path d="M19.5 21a3 3 0 003-3v-4.5a3 3 0 00-3-3h-1.5V4.5a3 3 0 00-3-3h-9a3 3 0 00-3 3v13.5a3 3 0 003 3h13.5zM6 4.5a1.5 1.5 0 011.5-1.5h9a1.5 1.5 0 011.5 1.5V9H7.5A1.5 1.5 0 006 10.5v7.5a1.5 1.5 0 01-1.5-1.5V4.5z" />
              </svg>
            }
            @case ('trophy') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M5.166 2.621v.858c-1.035.148-2.059.33-3.071.543a.75.75 0 00-.584.859 6.753 6.753 0 006.138 5.6 6.73 6.73 0 002.743 1.346A6.707 6.707 0 019.27 13.4H7.5a.75.75 0 000 1.5h1.173a4.502 4.502 0 003.327 3.327V20.25H10.5a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-1.5v-2.023a4.502 4.502 0 003.327-3.327H16.5a.75.75 0 000-1.5h-1.77a6.707 6.707 0 01-1.123-1.576 6.73 6.73 0 002.743-1.346 6.753 6.753 0 006.138-5.6.75.75 0 00-.584-.86 33.676 33.676 0 00-3.07-.542V2.62a.75.75 0 00-.75-.75h-7.382a.75.75 0 00-.75.75zm1.5.879h10.668v4.204a5.25 5.25 0 11-10.668 0V3.5z" clip-rule="evenodd" />
              </svg>
            }
            @case ('chart') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path d="M3 13.25a.75.75 0 01.75-.75h2.5a.75.75 0 01.75.75v6a.75.75 0 01-.75.75h-2.5a.75.75 0 01-.75-.75v-6zM10.25 8a.75.75 0 01.75-.75h2.5a.75.75 0 01.75.75v11.25a.75.75 0 01-.75.75h-2.5a.75.75 0 01-.75-.75V8zM17.5 3.5a.75.75 0 01.75-.75h2.5a.75.75 0 01.75.75v15.75a.75.75 0 01-.75.75h-2.5a.75.75 0 01-.75-.75V3.5z" />
              </svg>
            }
            @case ('star') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clip-rule="evenodd" />
              </svg>
            }
            @case ('doc-green') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm6.75 10.5a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zm0 3.75a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM7.5 12a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5H8.25A.75.75 0 017.5 12zm0 3.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5H8.25a.75.75 0 01-.75-.75z" clip-rule="evenodd" />
                <path d="M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z" />
              </svg>
            }
            @case ('alert') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
              </svg>
            }
            @case ('handshake') {
              <svg class="toast-icon stroke-current stroke-2 fill-none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />
              </svg>
            }
            @case ('target') {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm0 2.25a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 3a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 2.25a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clip-rule="evenodd" />
              </svg>
            }
            @default {
              <svg class="toast-icon fill-current" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 004.496 0 25.057 25.057 0 01-4.496 0z" clip-rule="evenodd" />
              </svg>
            }
          }
        </div>

        <!-- Details: Clean Title & Body from Backend -->
        <div class="toast-details">
          <h4 class="toast-title">
            {{ toast.title }}
          </h4>

          @if (toast.body) {
            <p class="toast-body">
              {{ toast.body }}
            </p>
          }

          @if (toast.route && toast.route.length > 0) {
            <div class="toast-action">
              <span>View details</span>
              <svg class="toast-action-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          }
        </div>

        <!-- Dismiss Button -->
        <button
          type="button"
          class="toast-close-btn"
          (click)="onDismiss($event, toast.id)"
          aria-label="Dismiss notification"
        >
          <svg class="toast-close-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Animated Progress Countdown Bar -->
      <div class="toast-progress-track">
        <div
          class="toast-progress-bar"
          [style.width.%]="toast.progressPercent"
        ></div>
      </div>
    </div>
  }
</div>
